module.exports = __webpack_public_path__ + "static/media/el fath still 01.4cd4be1a.webp";